import createToolbar from './toolbar/createToolbar.js';
import { DEFAULTS, Component as VideoComponent } from './video-component.js';
import { VIDEO_TYPE_LEGACY, VIDEO_TYPE } from './types.js';
import { createBasePlugin } from 'wix-rich-content-plugin-commons';
import './toolbar/inline-buttons.js';
import 'wix-rich-content-editor-common';
import './modals.js';
import './toolbar/videoSelectionInputModal.js';
import 'prop-types';
import 'react';
import 'wix-rich-content-ui-components';
import 'wix-rich-content-common';
import './style-inject.es-746bb8ed.js';
import 'react-player';
import './toolbar/videoPluginService.js';
import 'lodash';
import './toolbar/VideoSettings.js';
import 'classnames';
import './toolbar/ControlsSection.js';
import './toolbar/videoModal.js';
import './toolbar/mediaURLInputModal.js';
import './toolbar/NewVideoModal.js';
import './toolbar/NewVideoInsertModal.js';
import './toolbar/videoUploadModal.js';
import './toolbar/NewMediaUrlInputModal.js';
import 'ricos-context';
import './toolbar/selectionModalCustomStyles.js';
import './constants.js';
import 'ricos-schema';
import './icons/MediaReplaceIcon.js';
import './toolbar/insert-buttons.js';
import './icons/VideoInsertPluginIcon.js';
import './icons/SoundCloudInsertPluginIcon.js';
import './icons/YoutubeIcon.js';
import 'react-dom';
import './video-viewer.js';
import './reactPlayerWrapper.js';
import 'wix-rich-content-common/dist/statics/schemas/plugin-video.schema.json';
import './get-video-source.js';
import './IframePlayer.js';
import './video-viewer-200c0e68.js';
import './default-video-styles-ee165d52.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __restKey = (key) => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const createVideoPlugin = (config) => {
  var _a, _c, _d;
  const _b = config, {
    helpers,
    t,
    [_a = VIDEO_TYPE]: settings = {},
    isMobile,
    spoilerWrapper,
    commonPubsub,
    experiments
  } = _b, rest = __objRest(_b, [
    "helpers",
    "t",
    __restKey(_a),
    "isMobile",
    "spoilerWrapper",
    "commonPubsub",
    "experiments"
  ]);
  const disableDownload = (_c = config == null ? void 0 : config.uiSettings) == null ? void 0 : _c.disableDownload;
  const defaultPluginData = disableDownload !== void 0 ? __spreadProps(__spreadValues({}, DEFAULTS), { disableDownload }) : DEFAULTS;
  const type = VIDEO_TYPE;
  return createBasePlugin(__spreadValues({
    component: VideoComponent,
    type,
    legacyType: VIDEO_TYPE_LEGACY,
    toolbar: createToolbar({
      t,
      settings: __spreadProps(__spreadValues({}, settings), { commonPubsub, type }),
      isMobile,
      disableDownload,
      experiments
    }),
    helpers,
    settings,
    t,
    isMobile,
    disableRightClick: (_d = config == null ? void 0 : config.uiSettings) == null ? void 0 : _d.disableRightClick,
    defaultPluginData,
    spoilerWrapper: settings.spoiler && spoilerWrapper,
    commonPubsub
  }, rest));
};
createVideoPlugin.functionName = VIDEO_TYPE;

export { createVideoPlugin };
//# sourceMappingURL=createVideoPlugin.js.map
